<div class="container">
    <div class="row from-top">
        <!-- Close -->
        <button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>

        <!-- Titles -->
        <div class="col-md-12 text-center">
            <i class="fa fa-info-circle fa-4x pb-4"></i>
            <h1>{{details?.title}}</h1>
        </div>

        <!-- Description -->
        <div class="col-md-12 mt-5">
            <p>
                <span class="font-weight-bold">{{('gen_description' | translate) + ': '}}</span>
                <span class="clr-sec-text">{{details.description}}</span>
            </p>
        </div>

        <!-- Other Info -->
        <div class="col-md-12">
            <!-- Directors -->
            <app-cast class="cast-dark-theme" [title]="'gen_director'" [cast]="cast?.directors"
                *ngIf="cast?.directors?.length">
            </app-cast>

            <!-- Actors -->
            <app-cast class="cast-dark-theme" [title]="'gen_actors'" [cast]="cast?.actors" *ngIf="cast?.actors?.length">
            </app-cast>

            <!-- Produced -->
            <p *ngIf="details.countries?.length">
                <span class="font-weight-bold">{{('gen_produced' | translate) + ': '}}</span>
                <span class="cast-align clr-sec-text">
                    <span *ngFor="let country of details.countries;let pos = index;">
                        {{(country | translate) + (pos != details.countries.length - 1 ? "," : "")}}
                    </span>
                </span>
            </p>
        </div>
    </div>
</div>